import { render, staticRenderFns } from "./Tipos.vue?vue&type=template&id=2bf38a1d&scoped=true&"
import script from "./Tipos.vue?vue&type=script&lang=js&"
export * from "./Tipos.vue?vue&type=script&lang=js&"
import style0 from "./Tipos.vue?vue&type=style&index=0&id=2bf38a1d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf38a1d",
  null
  
)

export default component.exports